module.exports = __webpack_public_path__ + "img/Pot1.4028e4a3.svg";